import { createSystem, defaultConfig, defineConfig } from '@chakra-ui/react';

export const system = createSystem(
  defaultConfig,
  defineConfig({
    preflight: false,
    theme: {
      tokens: {
        colors: {
          brand: {
            50: { value: '#eff6ff' },
            100: { value: '#dbeafe' },
            200: { value: '#bfdbfe' },
            300: { value: '#93c5fd' },
            400: { value: '#60a5fa' },
            500: { value: '#3b82f6' },
            600: { value: '#2563eb' },
            700: { value: '#1d4ed8' },
            800: { value: '#1e40af' },
            900: { value: '#1e3a8a' },
          },
        },
        radii: {
          lg: { value: '16px' },
          xl: { value: '18px' },
        },
        fonts: {
          body: {
            value:
              "system-ui, -apple-system, BlinkMacSystemFont, 'SF Pro Text', 'Segoe UI', sans-serif",
          },
          heading: {
            value:
              "system-ui, -apple-system, BlinkMacSystemFont, 'SF Pro Text', 'Segoe UI', sans-serif",
          },
        },
      },
      semanticTokens: {
        colors: {
          brand: {
            solid: { value: '{colors.brand.500}' },
            contrast: { value: 'white' },
            fg: { value: '{colors.brand.700}' },
            muted: { value: '{colors.brand.100}' },
            subtle: { value: '{colors.brand.200}' },
            emphasized: { value: '{colors.brand.600}' },
            focusRing: { value: '{colors.brand.500}' },
          },
          page: {
            bg: {
              value: { base: '#f3f6ff', _dark: '#0b1220' },
            },
            fg: {
              value: { base: '#0f172a', _dark: '#e2e8f0' },
            },
          },
          surface: {
            card: {
              value: {
                base: 'rgba(255, 255, 255, 0.92)',
                _dark: 'rgba(15, 23, 42, 0.88)',
              },
            },
            border: {
              value: {
                base: 'rgba(148, 163, 184, 0.45)',
                _dark: 'rgba(71, 85, 105, 0.55)',
              },
            },
          },
        },
      },
    },
  }),
);
